import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import TrafficlightButtonGreen from "../../../../../../../components/Button/TrafficlightButtonGreen";
import { TextSignalFam } from "./TextSignalFam";


export default function Fam_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen}>
    <TrafficlightButtonGreen  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Familial hypercholesterolemia (FH) - Analysis'

    content={ <TextSignalFam />}

/>
</>
)}